import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Button from 'components/common/Button';
import CustomButton from 'components/common/CustomButton';
import LanguageSwitcher from 'components/common/LanguageSwitcher';
import HeaderMenu from 'components/HeaderMenu';
import './style.scss';
import useWindowSize from 'hooks/useWindowSize';
import { getAllLangs } from 'utils/lang';

const HomeHeader = ({ openLogin, openSignup }) => {
    const { t } = useTranslation();
    const isMobile = 'xs' === useWindowSize().size;
    const availableLanguages = getAllLangs().filter(({ isAvailable }) => isAvailable);

    return (
        <header className="home-header" role="banner">
            <div className="home-header__header-menu__wrapper">
                <HeaderMenu
                    className="home-header__header-menu"
                    leftElement={(
                        <Link to="/account">
                            <img alt="Logo" src="/assets/vasco-logo.svg" />
                        </Link>
                    )}
                    rightElement={(
                        <div className="home-header__header-menu--right">
                            <CustomButton className="header-menu__login-button" onClick={() => openLogin()}>
                                <img alt="Menu" src="/assets/icons/person.svg" />
                                <span>{t('header_menu.login')}</span>
                            </CustomButton>
                            {!isMobile && availableLanguages.length > 1 && (
                                <>
                                    <div className="home-header__header-menu__pipe" />
                                    <LanguageSwitcher className="language-switcher__small" color="black" shortLabel />
                                </>
                            )}
                        </div>
                    )}
                />
            </div>
            <div className="home-header__container">
                <div className="home-header__intro">
                    <h1 className="home-header__title">{t('home.header.title')}</h1>
                    <h2 className="home-header__subtitle">{t('home.header.subtitle')}</h2>
                    <Button
                        className="button"
                        onClick={() => {
                            openSignup();
                        }}
                        text={t('home.start_button')}
                    />
                </div>
                <div className="home-header__wrapper-illustration">
                    <img
                        alt="header-illustration"
                        className="home-header__illustration"
                        src="/assets/vasco-home-header.svg"
                    />
                </div>
            </div>
        </header>
    );
};

HomeHeader.propTypes = {
    openLogin: PropTypes.func,
    openSignup: PropTypes.func,
};

export default HomeHeader;
